export default {"src":"https://js-static.hirist.tech/production/7.0.0/_next/static/media/man.3d535cfb.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};